export const C8yPactHttpControllerLogLevel = [
    "info",
    "debug",
    "warn",
    "error",
];
export const C8yPactHttpControllerDefaultMode = "forward";
export const C8yPactHttpControllerDefaultRecordingMode = "append";
